export default __webpack_public_path__ + "static/media/spin-bg-6.21bec572.png";